<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()" class="text item">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-2">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <el-select multiple collapse-tags
                  style="width: 100%"
                  class="select-primary select_modules  mb-3"
                  v-model="select_proyect"
                  @change="getDataByProyectDates"
                  filterable placeholder="Proyecto">
                  <el-option v-for="option in proyects"
                              class="select-primary"
                              :value="option.nombre"
                              :label="option.nombre"
                              :key="option.nombre">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-date-picker
                  class="picker-filter"
                  style="width: 100%"
                  :clearable="false"
                  v-model="rangeDate"
                  type="daterange"
                  @change="getDataByProyectDates"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  start-placeholder="Fecha Inicial"
                  end-placeholder="Fecha Final"
                  align="center">
                </el-date-picker>
              </div>
              <div class="col-6 col-sm-4 col-md-3" style="width: 100%">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('calidad_atencion_usuarios', 'Calidad en la atención al usuario', 'a4', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('calidad_atencion_usuarios', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('calidad_atencion_usuarios', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <br class="c-none">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
      <div class="row">
        <div class="col-4">
          <div class="text-right">
            <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('calidad_atencion_usuarios', 'Calidad en la atención al usuario', 'a4', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
                Exportar a PDF
            </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center">
            <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('calidad_atencion_usuarios', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
            Exportar a Excel
          </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-left">
            <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('calidad_atencion_usuarios', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
              Exportar a CSV
            </button>
          </div>
        </div>
      </div>
      <br/>
      <card class="custom-shadow-card-header">
        <span v-if="Object.keys(chartOptions1).length > 0">
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions1"></highcharts>
            </div>
          </div>
        </span>
      </card>
      <card class="custom-shadow-card-header">
        <span v-if="Object.keys(chartOptions2).length > 0">
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions2"></highcharts>
            </div>
          </div>
        </span>
      </card>
      <card class="custom-shadow-card-header">
        <span v-if="Object.keys(chartOptions3).length > 0">
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions3"></highcharts>
            </div>
          </div>
        </span>
      </card>
      <card class="custom-shadow-card-header">
        <span v-if="Object.keys(chartOptions4).length > 0">
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions4"></highcharts>
            </div>
          </div>
        </span>
      </card>
    </div>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import mixinCharts from "src/util/mixinCharts"
  import table from './qualityUserSupportsTable'
  import moment from 'moment'
  import {Chart} from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import exportingInit from 'highcharts/modules/exporting'

  exportingInit(Highcharts)

  export default {
    components: {
      highcharts: Chart
    },

    data () {
      return {
        monitoringForm: {},
        proyects: [],
        select_proyect: [],
        monitorings: null,
        tableColumns: table,
        isShow: true,
        rangeDate: [new Date(new Date().getFullYear(), 0, 1), new Date()],
        chartOptions1: {},
        chartOptions2: {},
        chartOptions3: {},
        chartOptions4: {},
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker, mixinCharts],
    methods: {
      getDataByProyectDates() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='qualityusersupports/index'
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')
        let proyects = this.select_proyect.map(elem => { return "'"+elem+"'" })
        data.proyect = (this.select_proyect.length == 0) ? '' : proyects.join()

        this.saveMaster(data).then((response) => {
          this.tableData = response.data.quality_users_supports
          this.proyects = response.data.proyects
          this.searchFuse(table.map(prop => { return prop.prop }))
          this.chartOptions1 = this.columns(response.data.chart1, null)
          this.chartOptions2 = this.columns(response.data.chart2, null)
          this.chartOptions3 = this.pieChart(response.data.chart3, null)
          this.chartOptions4 = this.pieChart(response.data.chart4, null)
          self.$emit('cotentLoading', false)

        }).catch((error) => {
          console.log(error)
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
    },
    created(){
      if(this.canIndex()) {
        this.getDataByProyectDates()
      }
    }
  }
</script>
